import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "common/config-api";
import api from 'api';

const formatDate = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const typeLabel = (type) => {
    const map = {
        door: '방문',
        purchase: '구매',
        online: '온라인',
        _door: '중복(방문)',
        _purchase: '중복(구매)',
        _online: '중복(온라인)',
    };
    return map[type] ?? type;
};

const UserAttendanceRow = ({ row, onView }) => {
    const isDuplicate = row.userAttendanceType?.startsWith('_');
    const time = row.userAttendanceDate
        ? row.userAttendanceDate.substring(11, 16)
        : '-';

    return (
        <tr>
            <td>{time}</td>
            <td>{row.userNickname ?? '-'}</td>
            <td>{row.userAttendancePoint}</td>
            <td>{row.userPoint?.toLocaleString() ?? 0}</td>
            <td>{typeLabel(row.userAttendanceType)}</td>
            <td>
                <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    disabled={isDuplicate}
                    onClick={() => !isDuplicate && onView(row.userCode)}
                >
                    보기
                </button>
            </td>
        </tr>
    );
};

const UserAttendance = () => {
    const navigate = useNavigate();
    const today = formatDate(new Date());

    const [date, setDate] = useState(today);
    const [attendanceList, setAttendanceList] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchAttendanceList = async (targetDate) => {
        setLoading(true);
        try {
            const res = await api.get(`${API.USER_ATTENDANCE_DATE}`, {
                params: { date: targetDate }
            });
            setAttendanceList(res.data || []);
        } catch (err) {
            console.error('출석 목록 조회 실패:', err);
            setAttendanceList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAttendanceList(today);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSearch = () => {
        fetchAttendanceList(date);
    };

    const handleView = (userCode) => {
        navigate(`/user/${userCode}`);
    };

    return (
        <div className="row">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">회원 출석 현황</h5>

                    <div className="row mb-3">
                        <div className="col-sm-2">
                            <input
                                type="date"
                                className="form-control"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSearch}
                                disabled={loading}
                            >
                                {loading ? '조회 중...' : '검색'}
                            </button>
                        </div>
                    </div>

                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>출석시간</th>
                                <th>회원명</th>
                                <th>적립포인트</th>
                                <th>누적포인트</th>
                                <th>출석타입</th>
                                <th>회원정보</th>
                            </tr>
                        </thead>
                        <tbody>
                            {attendanceList.length === 0 ? (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">
                                        {loading ? '로딩 중...' : '출석 데이터가 없습니다.'}
                                    </td>
                                </tr>
                            ) : (
                                attendanceList.map((row, idx) => (
                                    <UserAttendanceRow
                                        key={row.userAttendanceIdx ?? idx}
                                        row={row}
                                        onView={handleView}
                                    />
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default UserAttendance;
